<div class="hero-container">
  <div class="hero-wrapper">
    <div class="wizard-container wizard-static-height">
      <app-wizard
        [checkFormNumber]="checkFormNumber.bind(this)"
        [googleApiKey]="googleApiKey"
        [questionStart]="questionStart"
        (questionStartChange)="questionStartChange.emit($event)"
      />
    </div>

    <div class="hero-info-container">
      <div class="hero-info-cards-wrapper">
        <div
          *ngFor="let card of infoCards"
          class="hero-info-card d-flex flex-row gap-size-10"
        >
          <img
            [src]="card.userImage"
            [alt]="card.userName"
            class="object-fit-cover rounded-3"
          />
          <div class="d-flex flex-column justify-content-center gap-size-10">
            <p class="info-card-amount">${{ card.amount | number }} {{ card.sideTitle }}</p>
            <div>
              <!-- <p class="info-card-received-info">
                {{ card.userName }} received a loan for
              </p> -->
              <p class="info-card-purpose">{{ card.purpose }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <img src="assets/heroBg.png" alt="heroBgImage" class="hero-bg-image" />
  </div>
</div>
